"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IEntryEvent = void 0;
var IEntryEvent;
(function (IEntryEvent) {
    IEntryEvent[IEntryEvent["DAYS_1"] = 1] = "DAYS_1";
    IEntryEvent[IEntryEvent["WEEKS_2"] = 2] = "WEEKS_2";
    IEntryEvent[IEntryEvent["MONTHS_3"] = 3] = "MONTHS_3";
    IEntryEvent[IEntryEvent["YEARS_4"] = 4] = "YEARS_4";
    IEntryEvent[IEntryEvent["SINGLE_5"] = 5] = "SINGLE_5";
    IEntryEvent[IEntryEvent["AUTH_6"] = 6] = "AUTH_6";
    IEntryEvent[IEntryEvent["CAPTURE_7"] = 7] = "CAPTURE_7";
    IEntryEvent[IEntryEvent["REFUND_8"] = 8] = "REFUND_8";
    IEntryEvent[IEntryEvent["BOARD_9"] = 9] = "BOARD_9";
    IEntryEvent[IEntryEvent["PAYOUT_10"] = 10] = "PAYOUT_10";
    IEntryEvent[IEntryEvent["CHARGEBACK_11"] = 11] = "CHARGEBACK_11";
    IEntryEvent[IEntryEvent["OVERDRAFT_12"] = 12] = "OVERDRAFT_12";
    IEntryEvent[IEntryEvent["INTERCHANGE_13"] = 13] = "INTERCHANGE_13";
    IEntryEvent[IEntryEvent["PROCESSOR_14"] = 14] = "PROCESSOR_14";
    IEntryEvent[IEntryEvent["ACHFAIL_15"] = 15] = "ACHFAIL_15";
    IEntryEvent[IEntryEvent["ACCOUNT_16"] = 16] = "ACCOUNT_16";
    IEntryEvent[IEntryEvent["SIFT_17"] = 17] = "SIFT_17";
    IEntryEvent[IEntryEvent["ADJUSTMENT_18"] = 18] = "ADJUSTMENT_18";
    IEntryEvent[IEntryEvent["RETRIEVAL_19"] = 19] = "RETRIEVAL_19";
    IEntryEvent[IEntryEvent["ARBITRATION_20"] = 20] = "ARBITRATION_20";
    IEntryEvent[IEntryEvent["ECSALE_21"] = 21] = "ECSALE_21";
    IEntryEvent[IEntryEvent["ECREFUND_22"] = 22] = "ECREFUND_22";
    IEntryEvent[IEntryEvent["ECRETURN_23"] = 23] = "ECRETURN_23";
    IEntryEvent[IEntryEvent["SETTLEMENT_24"] = 24] = "SETTLEMENT_24";
    IEntryEvent[IEntryEvent["MISUSE_25"] = 25] = "MISUSE_25";
    IEntryEvent[IEntryEvent["PROFIT_SHARE_26"] = 26] = "PROFIT_SHARE_26";
    IEntryEvent[IEntryEvent["UNAUTH_27"] = 27] = "UNAUTH_27";
    IEntryEvent[IEntryEvent["ACHNOC_28"] = 28] = "ACHNOC_28";
    IEntryEvent[IEntryEvent["ECNOC_29"] = 29] = "ECNOC_29";
    IEntryEvent[IEntryEvent["ECFAIL_30"] = 30] = "ECFAIL_30";
    IEntryEvent[IEntryEvent["ECNSF_31"] = 31] = "ECNSF_31";
    IEntryEvent[IEntryEvent["CURRENCY_CONVERSION_32"] = 32] = "CURRENCY_CONVERSION_32";
    IEntryEvent[IEntryEvent["TERMINAL_TXN_33"] = 33] = "TERMINAL_TXN_33";
    IEntryEvent[IEntryEvent["REVERSE_PAYOUT_34"] = 34] = "REVERSE_PAYOUT_34";
    IEntryEvent[IEntryEvent["PARTIAL_REVERSE_PAYOUT_35"] = 35] = "PARTIAL_REVERSE_PAYOUT_35";
    IEntryEvent[IEntryEvent["PAYMENT_CHECK_43"] = 43] = "PAYMENT_CHECK_43";
    IEntryEvent[IEntryEvent["PAYMENT_UPDATE_44"] = 44] = "PAYMENT_UPDATE_44";
    IEntryEvent[IEntryEvent["PAYMENT_GROUP_CHECK_45"] = 45] = "PAYMENT_GROUP_CHECK_45";
    IEntryEvent[IEntryEvent["PAYMENT_GROUP_UPDATE_46"] = 46] = "PAYMENT_GROUP_UPDATE_46";
    IEntryEvent[IEntryEvent["ENTRY_REFUND_47"] = 47] = "ENTRY_REFUND_47";
    IEntryEvent[IEntryEvent["DEFAULT_51"] = 51] = "DEFAULT_51";
    IEntryEvent[IEntryEvent["DEFAULT_52"] = 52] = "DEFAULT_52";
    IEntryEvent[IEntryEvent["DEFAULT_53"] = 53] = "DEFAULT_53";
    IEntryEvent[IEntryEvent["DEFAULT_54"] = 54] = "DEFAULT_54";
    IEntryEvent[IEntryEvent["DEFAULT_55"] = 55] = "DEFAULT_55";
    IEntryEvent[IEntryEvent["DEFAULT_56"] = 56] = "DEFAULT_56";
    IEntryEvent[IEntryEvent["DEFAULT_57"] = 57] = "DEFAULT_57";
    IEntryEvent[IEntryEvent["DEFAULT_58"] = 58] = "DEFAULT_58";
    IEntryEvent[IEntryEvent["DEFAULT_59"] = 59] = "DEFAULT_59";
    IEntryEvent[IEntryEvent["DEFAULT_60"] = 60] = "DEFAULT_60";
    IEntryEvent[IEntryEvent["DEFAULT_61"] = 61] = "DEFAULT_61";
    IEntryEvent[IEntryEvent["DEFAULT_62"] = 62] = "DEFAULT_62";
    IEntryEvent[IEntryEvent["DEFAULT_63"] = 63] = "DEFAULT_63";
    IEntryEvent[IEntryEvent["DEFAULT_64"] = 64] = "DEFAULT_64";
    IEntryEvent[IEntryEvent["DEFAULT_65"] = 65] = "DEFAULT_65";
    IEntryEvent[IEntryEvent["DEFAULT_66"] = 66] = "DEFAULT_66";
    IEntryEvent[IEntryEvent["DEFAULT_67"] = 67] = "DEFAULT_67";
    IEntryEvent[IEntryEvent["DEFAULT_68"] = 68] = "DEFAULT_68";
    IEntryEvent[IEntryEvent["DEFAULT_69"] = 69] = "DEFAULT_69";
    IEntryEvent[IEntryEvent["DEFAULT_70"] = 70] = "DEFAULT_70";
    IEntryEvent[IEntryEvent["DEFAULT_71"] = 71] = "DEFAULT_71";
})(IEntryEvent = exports.IEntryEvent || (exports.IEntryEvent = {}));
